import styled, { css } from 'styled-components';
import SlickSlider from 'react-slick';
import { media } from '~constants/media';
import createMedia from '~utils/createMedia';
import { Camera } from 'styled-icons/feather/Camera';
import { BookContent } from 'styled-icons/boxicons-regular/BookContent';

const ICON_COLOR = 'rgb(128, 128, 128)';

const sliderBtnCSS = css<{ isActive: boolean }>`
  width: 20px;
  height: 20px;
  cursor: pointer;

  ${({ isActive }) => css`
    opacity: ${isActive ? '1' : '0.4'};
  `};
`;

// for newQuiz/steps
export const customMedia = createMedia({
  lg: 1300,
});

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const StyledSlickSlider = styled(SlickSlider)<{
  desktopSmallView?: boolean;
}>`
  /* fixes slider having huge width inside tables https://github.com/kenwheeler/slick/issues/2594 */
  min-width: 100%;
  width: 0;
  height: 100%;
  overflow: hidden;

  .slick-list {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  .slick-track,
  .slick-slide,
  .slick-slide div {
    height: 100%;
  }

  ${({ desktopSmallView }) => css`
    padding-top: 56.25%;

    ${media.lg`
      ${!desktopSmallView &&
        `
        display: flex;
        flex-direction: column;
      `}
    `}

    ${customMedia.lg`
      ${desktopSmallView &&
        `
        display: flex;
        flex-direction: column;
      `}
    `}
  `};
`;

export const SliderFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-top: 15px;
`;

export const SliderPlanBtn = styled(BookContent)<{ isActive: boolean }>`
  margin-left: 5px;
  fill: ${ICON_COLOR};
  ${sliderBtnCSS};
`;

export const SliderPhotoBtn = styled(Camera)<{ isActive: boolean }>`
  margin-left: 10px;
  stroke: ${ICON_COLOR};
  ${sliderBtnCSS};
`;

export const SliderArrowWrapper = styled.div``;

export const SliderArrow = styled.div<{ direction: 'left' | 'right' }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 50%;
  transform: translateY(-50%);
  height: 53px;
  width: 33px;
  background-color: rgb(214, 220, 229, 0.8);
  z-index: 2;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  ${({ direction }) => {
    if (direction === 'right')
      return `
         right: 0;
         border-top-left-radius: 5px;
         border-bottom-left-radius: 5px;
       `;
    if (direction === 'left')
      return `
         left: 0;
         border-top-right-radius: 5px;
         border-bottom-right-radius: 5px;
       `;

    return '';
  }}
`;

export const SliderImage = styled.div<{ src: string }>`
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  cursor: zoom-in;
  ${({ src }) => `background-image: url(${src});`};
`;

export const SliderFavoritesButtonWrapper = styled.span`
  margin-left: 8px;

  ${media.lg`
    display: none;
  `}
`;

export const ID = styled.span`
  font-size: 14px;
  font-weight: 600;
`;
